import React from 'react';
import Styled from './AdminEditor.styled';

import successIcon from '../../../../images/success-icon.svg';
import { GradientButton } from 'components/UI/Buttons';

export interface IAdminEditModalSave {
    show: boolean;
    onHide: () => void;
}

const AdminEditModalSave = ({ show, onHide }: IAdminEditModalSave) => {
    return (
        <Styled.Modal show={show} onHide={onHide}>
            <Styled.Center>
                <img src={successIcon} style={{ width: '50px' }} />
                <br />

                <Styled.TextModal>O conteúdo foi salvo!</Styled.TextModal>
                <br />
                <br />
                <Styled.ContainerBottom style={{ textAlign: 'center' }}>
                    <GradientButton onClick={onHide}>Fechar</GradientButton>
                </Styled.ContainerBottom>
            </Styled.Center>
        </Styled.Modal>
    );
};

export default AdminEditModalSave;
